import { render, staticRenderFns } from "./ElectronicRequirement.vue?vue&type=template&id=30d808d8&scoped=true"
import script from "./ElectronicRequirement.vue?vue&type=script&lang=js"
export * from "./ElectronicRequirement.vue?vue&type=script&lang=js"
import style0 from "./ElectronicRequirement.vue?vue&type=style&index=0&id=30d808d8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d808d8",
  null
  
)

export default component.exports